import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { ApplicationHttpClient } from '@app/core/http';

import { Credential } from '@app/core/models';

const CREDENTIAL_STORAGE = 'CREDENTIALS';
const REMEMBERME_STORAGE = 'REMEMBERME';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private credentialSubject: BehaviorSubject<Credential>;
  public credentials: Observable<Credential>;

  constructor(private http: ApplicationHttpClient) {
    this.credentialSubject = new BehaviorSubject<Credential>(JSON.parse(localStorage.getItem(CREDENTIAL_STORAGE)));
    this.credentials = this.credentialSubject.asObservable();
  }

  public get currentCredentials(): Credential {
    return JSON.parse(localStorage.getItem(CREDENTIAL_STORAGE));
  }

  public login(userId: string, password: string, isForeigner: any, isIntegration : any): Observable<any> {
    return this.http.post('/session/login', {
      userId,
      password,
      isForeigner,
      isIntegration
    })
    .pipe(
      map(data => {
        return this.storeCredentials(data);
      })
    );
  }

  public InfoLogin(token: string) {
    return this.http.get(`/session/information-login?token=${token}`);
  }

  public logout() {
    this.http.delete('/session/logout').toPromise();

    localStorage.removeItem(CREDENTIAL_STORAGE);
    this.credentialSubject.next(null);
  }

  public requestResetPassword(body) {
    return this.http.post('/session/reset-password', body);
  }

  public getUserByToken(token: string) {
    return this.http.get('/session/account-info', {
      params: { token }
    });
  }

  public resetPassword(token: string, password: string, confirmPassword: string) {
    return this.http.post(`/session/change-password?token=${token}`, {
      password,
      confirmPassword
    });
  }

  public getCredentialToken() {
    const currentCredentials = this.currentCredentials;

    if (currentCredentials && currentCredentials.token) {
      return currentCredentials.token;
    }
  }

  public storeCredentials(data) {
    const credentials: Credential = {
      token: data.token,
      userId: data.userId,
      username: data.username,
      email: data.email,
      currentDate: data.currentDate,
      companyInfo: data.company,
      role: data.role
    };

    localStorage.setItem(CREDENTIAL_STORAGE, JSON.stringify(credentials));

    this.credentialSubject.next(credentials);

    return credentials;
  }

  public updateCompanyInStorage(companyInfo) {
    const credentials = JSON.parse(localStorage.getItem(CREDENTIAL_STORAGE));
    credentials.companyInfo = companyInfo;
    localStorage.setItem(CREDENTIAL_STORAGE, JSON.stringify(credentials));
    this.credentialSubject.next(credentials);
  }

  public saveRememberMe(objectLoginFrom) {
    if (objectLoginFrom.remember) {
      localStorage.setItem(REMEMBERME_STORAGE, JSON.stringify(objectLoginFrom));
    } else {
      localStorage.removeItem(REMEMBERME_STORAGE);
    }    
  }

  public getAutoLogin() {
    return JSON.parse(localStorage.getItem(REMEMBERME_STORAGE));
  }
}
